<div class="pr-3 pl-4 h-full w-full flex flex-col" (window:resize)="onResize()">
  <div class="flex justify-between header-table" #pageOptionBtnGroup>
    <div class="title-page"><span class="title">Danh sách nhân sự&nbsp;</span><breadcrumbs [items]="breadcrumbs"></breadcrumbs></div>
    <div class="btn-option flex">
        <ng-container *ngIf="btnType === buttonTypeEnum.ICON; then btnTypeIcon">
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXT; then btnTypeText">
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON; then btnTypeIconText">
        </ng-container>
      </div>
  </div>
  <form nz-form [formGroup]="validateForm" class="ant-advanced-search-form" #pageSearch>
    <div nz-row [nzGutter]="24">
      <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="quanHuyen">Đơn vị</nz-form-label>
          <nz-form-control nzSpan="24" nzHasFeedback nzValidatingTip="Validating...">
            <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả" formControlName="quanHuyen">
              <nz-option nzValue="1" nzLabel="Tất cả"></nz-option>
              <nz-option nzValue="2" nzLabel="Sở GD & ĐT"></nz-option>
              <nz-option nzValue="3" nzLabel="Phòng GD & ĐT"></nz-option>
              <nz-option nzValue="4" nzLabel="Trường"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="maHs">Phòng GD & ĐT</nz-form-label>
          <nz-form-control nzSpan="24" >
            <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả" formControlName="quanHuyen" [nzDisabled]="true">
              <nz-option nzValue="1" nzLabel="Tất cả"></nz-option>
              <nz-option nzValue="2" nzLabel="Sở GD & ĐT"></nz-option>
              <nz-option nzValue="3" nzLabel="Phòng GD & ĐT"></nz-option>
              <nz-option nzValue="4" nzLabel="Trường"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="hoTen">Quận huyện</nz-form-label>
          <nz-form-control nzSpan="24" >
            <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả" formControlName="quanHuyen">
              <nz-option nzValue="256" nzLabel="Thành phố Bắc Ninh"></nz-option>
              <nz-option nzValue="258" nzLabel="Huyện Yên Phong"></nz-option>
              <nz-option nzValue="259" nzLabel="Huyện Quế Võ"></nz-option>
              <nz-option nzValue="260" nzLabel="Huyện Tiên Du"></nz-option>
              <nz-option nzValue="263" nzLabel="Huyện Gia Bình"></nz-option>
              <nz-option nzValue="264" nzLabel="Huyện Lương Tài"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="hoTen">Cấp học</nz-form-label>
          <nz-form-control nzSpan="24" >
            <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả" formControlName="quanHuyen">
              <nz-option nzValue="MG" nzLabel="Mẫu giáo"></nz-option>
              <nz-option nzValue="TH" nzLabel="Tiểu học"></nz-option>
              <nz-option nzValue="THCS" nzLabel="THCS"></nz-option>
              <nz-option nzValue="THPT" nzLabel="THPT"></nz-option>
              <nz-option nzValue="GDTX" nzLabel="Giáo dục thường xuyên"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="hoTen">Trường</nz-form-label>
          <nz-form-control nzSpan="24" >
            <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả" formControlName="quanHuyen">
              <nz-option nzValue="1" nzLabel="Trường mầm non Tam Đa"></nz-option>
              <nz-option nzValue="2" nzLabel="Trường THPT Tam Thọ"></nz-option>
              <nz-option nzValue="3" nzLabel="Trường liên cấp Lý Công Uẩn"></nz-option>
              <nz-option nzValue="4" nzLabel="Trường TH và THCS Minh Tân"></nz-option>
              <nz-option nzValue="5" nzLabel="Trường TH và THCS Trần Quốc Toản"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="hoTen">Phòng ban</nz-form-label>
          <nz-form-control nzSpan="24" >
            <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả" formControlName="quanHuyen">
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <ng-container *ngIf="!isCollapse" #pageExpandedSearch>
        <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="hoTen">Mã nhân sự</nz-form-label>
            <nz-form-control nzSpan="24" >
              <input nz-input  formControlName="diaChi" />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="hoTen">Họ tên</nz-form-label>
            <nz-form-control nzSpan="24" >
              <input nz-input  formControlName="diaChi" />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="gioiTinh">Giới tính</nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-radio-group formControlName="gioiTinh">
                <label nz-radio nzValue="tatCa">Tất cả</label>
                <label nz-radio nzValue="nam">Nam</label>
                <label nz-radio nzValue="nu">Nữ</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="hoTen">Chức vụ</nz-form-label>
            <nz-form-control nzSpan="24" >
              <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả" formControlName="quanHuyen">
                <nz-option nzValue="1" nzLabel="Cấp mầm non"></nz-option>
                <nz-option nzValue="2" nzLabel="Cấp tiểu học"></nz-option>
                <nz-option nzValue="3" nzLabel="Cấp THCS"></nz-option>
                <nz-option nzValue="4" nzLabel="Cấp THPT"></nz-option>
                <nz-option nzValue="5" nzLabel="Chuyên viên"></nz-option>
                <nz-option nzValue="5" nzLabel="Giám đốc"></nz-option>
                <nz-option nzValue="5" nzLabel="Hiệu trưởng"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="hoTen">Loại hợp đồng</nz-form-label>
            <nz-form-control nzSpan="24" >
              <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả" formControlName="quanHuyen">
                <nz-option nzValue="1" nzLabel="Hợp đồng lao động từ 1 năm trở xuống"></nz-option>
                <nz-option nzValue="2" nzLabel="Hợp đồng lao động trên 1 năm"></nz-option>
                <nz-option nzValue="3" nzLabel="Hợp đồng lao động nghị định"></nz-option>
                <nz-option nzValue="4" nzLabel="Cấp THPT"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="hoTen">Loại nhân sự</nz-form-label>
            <nz-form-control nzSpan="24" >
              <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả" formControlName="quanHuyen">
                <nz-option nzValue="1" nzLabel="Cán bộ"></nz-option>
                <nz-option nzValue="2" nzLabel="Nhân viên"></nz-option>
                <nz-option nzValue="3" nzLabel="Giáo viên"></nz-option>
                <nz-option nzValue="4" nzLabel="Giáo viên dạy nghề"></nz-option>
                <nz-option nzValue="5" nzLabel="Lãnh đạo sở GD & ĐT"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="gioiTinh">Ngày sinh</nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-range-picker formControlName="ngaySinh" (ngModelChange)="onChange($event)"></nz-range-picker>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="hoTen">Dân tộc</nz-form-label>
            <nz-form-control nzSpan="24" >
              <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả" formControlName="quanHuyen">
                <nz-option nzValue="256" nzLabel="Ba Na"></nz-option>
                <nz-option nzValue="258" nzLabel="Bố Y"></nz-option>
                <nz-option nzValue="259" nzLabel="Ê Đê"></nz-option>
                <nz-option nzValue="260" nzLabel="Brâu"></nz-option>
                <nz-option nzValue="263" nzLabel="Co"></nz-option>
                <nz-option nzValue="264" nzLabel="Cống"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="hoTen">Tôn giáo</nz-form-label>
            <nz-form-control nzSpan="24" >
              <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả" formControlName="quanHuyen">
                <nz-option nzValue="1" nzLabel="Công giáo"></nz-option>
                <nz-option nzValue="2" nzLabel="Cao Đài"></nz-option>
                <nz-option nzValue="3" nzLabel="Hồi giáo"></nz-option>
                <nz-option nzValue="4" nzLabel="Phật giáo"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="hoTen">Chuyên ngành</nz-form-label>
            <nz-form-control nzSpan="24" >
              <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả" formControlName="quanHuyen">
                <nz-option nzValue="1" nzLabel="Chuyên ngành khác"></nz-option>
                <nz-option nzValue="2" nzLabel="Giáo dục công dân"></nz-option>
                <nz-option nzValue="3" nzLabel="Giáo dục chính trị"></nz-option>
                <nz-option nzValue="4" nzLabel="Giáo dục đặt biệt"></nz-option>
                <nz-option nzValue="5" nzLabel="Giáo dục mầm non"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="hoTen">Số CMND</nz-form-label>
            <nz-form-control nzSpan="24" >
              <input nz-input  formControlName="diaChi" />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="hoTen">Chuyên ngành</nz-form-label>
            <nz-form-control nzSpan="24" >
              <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả" formControlName="quanHuyen">
                <nz-option nzValue="1" nzLabel="Chuyên ngành khác"></nz-option>
                <nz-option nzValue="2" nzLabel="Giáo dục công dân"></nz-option>
                <nz-option nzValue="3" nzLabel="Giáo dục chính trị"></nz-option>
                <nz-option nzValue="4" nzLabel="Giáo dục đặt biệt"></nz-option>
                <nz-option nzValue="5" nzLabel="Giáo dục mầm non"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="hoTen">Học vấn</nz-form-label>
            <nz-form-control nzSpan="24" >
              <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả" formControlName="quanHuyen">
                <nz-option nzValue="1" nzLabel="03/12 - 03/12"></nz-option>
                <nz-option nzValue="2" nzLabel="05/12 - 05/12"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="hoTen">Học hàm</nz-form-label>
            <nz-form-control nzSpan="24" >
              <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả" formControlName="quanHuyen">
                <nz-option nzValue="1" nzLabel="Chưa xác định"></nz-option>
                <nz-option nzValue="2" nzLabel="Giáo sư"></nz-option>
                <nz-option nzValue="3" nzLabel="Phó giáo sư"></nz-option>
                <nz-option nzValue="4" nzLabel="Viện sĩ"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="danToc">Học vị</nz-form-label>
            <nz-form-control nzSpan="24" nzHasFeedback nzValidatingTip="Validating...">
              <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả" formControlName="danToc">
                <nz-option nzValue="1" nzLabel="Tiến sĩ"></nz-option>
                <nz-option nzValue="2" nzLabel="Tiến sĩ khoa học"></nz-option>
                <nz-option nzValue="3" nzLabel="Thạc sĩ"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="gioiTinh">Đảng viên</nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-radio-group formControlName="gioiTinh">
                <label nz-radio nzValue="tatCa">Tất cả</label>
                <label nz-radio nzValue="co">Có</label>
                <label nz-radio nzValue="khong">Không</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="dienChinhSach">Danh hiệu</nz-form-label>
            <nz-form-control nzSpan="24" nzHasFeedback nzValidatingTip="Validating...">
              <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả" formControlName="dienChinhSach">
                <nz-option nzValue="1" nzLabel="Chiến sĩ thi đua(Cơ sở)"></nz-option>
                <nz-option nzValue="2" nzLabel="Chiến sĩ thi đua cấp Tỉnh"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="khuyetTat">Ngoại ngữ</nz-form-label>
            <nz-form-control nzSpan="24" nzHasFeedback nzValidatingTip="Validating...">
              <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả" formControlName="khuyetTat">
                <nz-option nzValue="1" nzLabel="Tiếng Anh"></nz-option>
                <nz-option nzValue="2" nzLabel="Tiếng Đức"></nz-option>
                <nz-option nzValue="3" nzLabel="Tiếng Hàn"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="khuyetTat">C.chỉ vi tính</nz-form-label>
            <nz-form-control nzSpan="24" nzHasFeedback nzValidatingTip="Validating...">
              <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả" formControlName="khuyetTat">
                <nz-option nzValue="1" nzLabel="A"></nz-option>
                <nz-option nzValue="2" nzLabel="A,B"></nz-option>
                <nz-option nzValue="3" nzLabel="Cao đẳng"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="gioiTinh">Chấm dức HĐ</nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-radio-group formControlName="gioiTinh">
                <label nz-radio nzValue="tatCa">Tất cả</label>
                <label nz-radio nzValue="co">Có</label>
                <label nz-radio nzValue="khong">Không</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="khuyetTat">Hôn nhân</nz-form-label>
            <nz-form-control nzSpan="24" nzHasFeedback nzValidatingTip="Validating...">
              <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả" formControlName="khuyetTat">
                <nz-option nzValue="1" nzLabel="Chưa kết hôn"></nz-option>
                <nz-option nzValue="2" nzLabel="Đã kết hôn"></nz-option>
                <nz-option nzValue="3" nzLabel="Độc thân"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="gioiTinh">Về hưu</nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-radio-group formControlName="gioiTinh">
                <label nz-radio nzValue="tatCa">Tất cả</label>
                <label nz-radio nzValue="co">Về hưu</label>
                <label nz-radio nzValue="khong">Chưa về hưu</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="gioiTinh">ĐĐ/ TC</nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-radio-group formControlName="gioiTinh">
                <label nz-radio nzValue="tatCa">Tất cả</label>
                <label nz-radio nzValue="co">Có</label>
                <label nz-radio nzValue="khong">Không</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
      </ng-container>
      <div *ngIf="this.divisibleForFour" nz-col nzSpan="24">
        <div style="visibility: hidden; margin-top: 5px">hi</div>
      </div>
    </div>
    <div nz-row>
      <div nz-col [nzSpan]="24" class="search-area">
        <button nz-button class="flex items-center justify-center" [nzTooltipTitle]="isCollapse ? 'Mở rộng' : 'Đóng'" nz-tooltip (click)="toggleCollapse()"><i nz-icon nzType="filter" nzTheme="outline"></i></button>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
          <button nz-button class="flex items-center justify-center" (click)="resetForm()" nzTooltipTitle="Xóa tìm kiếm"
            nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear" nzTheme="outline"></i></button>
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'">Tìm kiếm</button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
          <button nz-button class="flex items-center justify-center" (click)="resetForm()"
            nzTooltipTitle="Xóa tìm kiếm"
            nzTooltipPlacement="bottom"
            nz-tooltip
          ><i nz-icon nzType="clear" nzTheme="outline"></i></button>
          <button nz-button class="flex items-center justify-center" style="width: 100px;" [nzType]="'primary'" 
            nzTooltipTitle="Tìm kiếm" 
            nzTooltipPlacement="bottom" 
            nz-tooltip><i nz-icon nzType="search" nzTheme="outline"></i></button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
          <button nz-button class="flex items-center justify-center" (click)="resetForm()" nzTooltipTitle="Xóa tìm kiếm"
            nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear" nzTheme="outline"></i></button>
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'"><i nz-icon nzType="search" nzTheme="outline" ></i>Tìm kiếm</button>
        </ng-container>
      </div>
    </div>
  </form>
  <div class="relative">
    <nz-table
      #hi
      nzOuterBordered
      nzShowSizeChanger
      [nzData]="listOfData"
      nzSize="small"
      [nzScroll]="{ y: height + 'px',x: width +'px' }"
      class="absolute w-full"
      [nzFrontPagination]="false"
      [nzTotal]="'50'"
      [nzPageSize]="'50'"
      [nzPageIndex]="'1'"
      [nzPageSizeOptions]= "[50, 100, 150]"
     >
      <thead>
        <tr #pageHeaderTable>
          <th nzWidth="50px" nzLeft [nzSortFn]="sortNameFn" [nzSortDirections]="'ascend'" >STT</th>
          <th nzWidth="100px" nzLeft>Mã</th>
          <th nzWidth="150px"nzLeft>Họ đệm</th>
          <th nzWidth="100px"nzLeft [nzSortFn]="sortNameFn">Tên</th>
          <th nzWidth="50px">Giới tính</th>
          <th nzWidth="120px">Ngày sinh</th>
          <th nzWidth="120px">Vị trí làm việc</th>
          <th nzWidth="100px">Chức vụ</th>
          <th nzWidth="300px">Loại hợp đồng</th>
          <th nzWidth="300px">Đơn vị</th>
          <th nzWidth="180px">Phòng ban</th>
          <th nzRight nzWidth="30px"></th>
          <th nzRight nzWidth="30px"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of hi.data">
          <td nzLeft>{{ data.numberIndex }}</td>
          <td nzLeft>{{ data.code }}</td>
          <td nzLeft>{{ data.firstName }}</td>
          <td nzLeft>{{ data.lastName }}</td>
          <td>{{ data.gender }}</td>
          <td>{{ data.dob }}</td>
          <td>{{ data.jobPosition }}</td>
          <td>{{ data.position }}</td>
          <td>{{ data.toc }}</td>
          <td>{{ data.unit }}</td>
          <td>{{ data.department }}</td>
          <td nzRight>
            <a nzTooltipTitle="Sửa" style="color:#1890ff; margin-right: 2em;" nzTooltipPlacement="top" (click)="showAddPersonel()" nz-tooltip>
              <i nz-icon nzType="edit" nzTheme="outline"></i>
            </a>
          </td>
          <td nzRight>
            <a nzTooltipTitle="Xóa" style="color:red" nzTooltipPlacement="top" (click)="showDeletePersonel()" nz-tooltip>
              <i nz-icon nzType="delete"nzTheme="outline"></i>
            </a>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
<ng-template #btnTypeIcon>
  <nz-upload
    class="flex items-start"
    nzAction="https://www.mocky.io/v2/5cc8019d300000980a055e76"
    [nzHeaders]="{ authorization: 'authorization-text' }"
    (nzChange)="handleChange($event)"
  >
    <button nz-button class="flex items-center justify-center" nzTooltipTitle="Xuất excel" nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="file-excel" nzTheme="twotone"></i></button>
  </nz-upload>
  <button
    class="flex items-center justify-center"
    nz-button nzTooltipTitle="In"
    nzTooltipPlacement="bottom"
    nz-tooltip
  >
    <i nz-icon nzType="printer" nzTheme="outline"></i>
  </button>
  <button
    class="flex items-center justify-center"
    nz-button nzTooltipTitle="Import nhân sự"
    nzTooltipPlacement="bottom"
    nz-tooltip
  >
    <i nz-icon nzType="import" nzTheme="outline"></i>
  </button>
  <button
    class="flex items-center justify-center"
    nz-button nzTooltipTitle="Trích xuất dữ liệu"
    nzTooltipPlacement="bottom"
    nz-tooltip
  >
    <i nz-icon nzType="export" nzTheme="outline"></i>
  </button>
  <button
  class="flex items-center justify-center"
  nz-button nzTooltipTitle="Thêm"
  nzTooltipPlacement="bottom"
  nz-tooltip
  (click)="showAddPersonel()"
  >
    <i nz-icon nzType="user-add" nzTheme="outline"></i>
  </button>
  <button
    class="flex items-center justify-center"
    (click)="showDeletePersonel()"
    nz-button
    nzType="primary"
    nzTooltipTitle="Xóa"
    nzTooltipPlacement="bottom"
    nz-tooltip
    nzDanger
  >
    <i nz-icon nzType="delete" nzTheme="outline" ></i>
  </button>
</ng-template>
<ng-template #btnTypeText>
  <nz-upload
    class="flex items-start"
    nzAction="https://www.mocky.io/v2/5cc8019d300000980a055e76"
    [nzHeaders]="{ authorization: 'authorization-text' }"
    (nzChange)="handleChange($event)"
  >
    <button
      nz-button
      class="flex items-center justify-center"
    >
      Xuất excel
    </button>
  </nz-upload>
  <button
    class="flex items-center justify-center"
    nz-button
  >
    In
  </button>
  <button
    class="flex items-center justify-center"
    nz-button
  >
    Import nhân sự
  </button>
  <button
    class="flex items-center justify-center"
    nz-button
  >
    Trích xuất dữ liệu
  </button>
  <button
    class="flex items-center justify-center"
    nz-button
    (click)="showAddPersonel()"
    >
    Thêm
  </button>
  <button
    class="flex items-center justify-center"
    (click)="showDeletePersonel()"
    nz-button
    nzType="primary"
    nzDanger
  >
    Xóa
  </button>
</ng-template>
<ng-template #btnTypeIconText>
  <nz-upload
    class="flex items-start"
    nzAction="https://www.mocky.io/v2/5cc8019d300000980a055e76"
    [nzHeaders]="{ authorization: 'authorization-text' }"
    (nzChange)="handleChange($event)"
  >
    <button
    nz-button
    class="flex items-center justify-center"
    >
    <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
    Xuất excel
  </button>
  </nz-upload>
  <button
    class="flex items-center justify-center"
    nz-button
    >
    <i nz-icon nzType="printer" nzTheme="outline"></i>In
  </button>
  <button
    class="flex items-center justify-center"
    nz-button
    >
    <i nz-icon nzType="import" nzTheme="outline"></i>Import nhân sự
  </button>
  <button
    class="flex items-center justify-center"
    nz-button
  >
    <i nz-icon nzType="export" nzTheme="outline"></i>Trích xuất dữ liệu
  </button>
  <button
    class="flex items-center justify-center"
    nz-button
    (click)="showAddPersonel()"
  >
    <i nz-icon nzType="user-add" nzTheme="outline"></i>Thêm
  </button>
  <button
    class="flex items-center justify-center"
    (click)="showDeletePersonel()"
    nz-button
    nzType="primary"
    nzDanger
  >
    <i nz-icon nzType="delete" nzTheme="outline" ></i>Xóa
  </button>
</ng-template>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
